import { ApLoaderDefault } from '@alixpartners/ui-components';
import { useState } from 'react';
import { TrumpedMatchClaimPopup } from './components/TrumpedMatchClaimPopup';
import { ClaimsTable } from './sections/ClaimsTable/ClaimsTable';
import { ClaimsData, SectionType, SubsectionType } from './types';

interface Props {
  claimsCount?: number;
  claimsData: ClaimsData;
  section: SectionType;
  subsection: SubsectionType;
  setSubsection: (s: SubsectionType) => void;
  disableResetFilters: boolean;
  onResetFilters?: () => unknown;
  onSectionClick: (section: SectionType) => unknown;
}

// depending on the whether Matching tab will have both contracts and claims,
// we might want to have it renamed to ClaimsContractsToolBody
export const ClaimsToolBody = ({
  claimsCount,
  section,
  claimsData,
  disableResetFilters,
  onResetFilters,
}: Props) => {
  const { trumpedMatchDialog } = claimsData;
  const [isColumnSelectionOpen, setColumnSelection] = useState(false);

  if (!claimsData) return null;

  if (!claimsData.gridColumnsReady)
    return <ApLoaderDefault className="loader-container" />;

  return (
    <>
      {trumpedMatchDialog && (
        <TrumpedMatchClaimPopup
          claimId={trumpedMatchDialog.matchedClaims}
          onAccept={trumpedMatchDialog.onAccept}
          onClose={trumpedMatchDialog.onCancel}
        />
      )}
      {section === SectionType.Claims && (
        <ClaimsTable
          claimsCount={claimsCount}
          claimsData={claimsData}
          isColumnSelectionOpen={isColumnSelectionOpen}
          disableResetFilters={disableResetFilters}
          onResetFilters={onResetFilters}
          setColumnSelection={setColumnSelection}
        />
      )}
    </>
  );
};
